export enum OrderEventType {
  PAID = 'Pago',
  DELIVERED = 'Entregue',
  CANCELED = 'Cancelado',
  IN_PRODUCTION = 'Em Produção'
}
